import styled from 'styled-components';

export const CompanyButtonContainer = styled.div.attrs({})`
  width: 100%;
  display: flex;
  gap: 16px;
`;

export const AddProposalContainer = styled.div.attrs({})`
  padding: 24px 0px;
`;

export const BotaoDocumento = styled.div.attrs({})`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 20px;
  width: auto;
  min-width: 110px;
  background-color: #f0f0f0;
  color: #333333;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  font-weight: 500;
  font-size: 16px;
  /* marge para descer o botao e da lateral, nao ficar muito colado*/
  margin-top: 16px;
  margin-right: 18px;
  /* mudar a aparencia do mouse para clicar */
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  outline: none;
  /* remove a marge no ultimo botao para nao ficar la em baixo */
  &:last-child {
    margin-right: 0;
  }
  /* muda a aparecencia do botao quando o mouse fica em cima */
  &:hover {
    color: #ffffff;
    background-color: #2670d1;
    border-color: #c0c0c0;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgb(0, 0, 0, 0.05);
  }
  /* muda a aparecencia quando cliacado. */
  &:active {
    background-color: #2670d1;
    color: #ffffff;
    border-color: #2670d1;
    transform: translateY(0);
    box-shadow: none;
  }
  &:focus {
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
  }
`;
